import { createSlice } from "@reduxjs/toolkit";
import {
  fetchPlans,
  fetchMySubscription,
  startCheckout,
  cancelMySubscription,
  resumeMySubscription,
  changeMyPlan,
  applyCoupon,
} from "../thunks/subscriptionThunk";

const initialState = {
  plans: { data: [], loading: false, error: null },
  mySubscription: { data: null, loading: true, error: null },
  checkout: { loading: false, error: null },
  action: { loading: false, error: null },
  coupon: {
    loading: false,
    error: null,
    data: null, // { valid, discountType, discountValue, originalPrice, discountAmount, finalPrice, currency }
  },
};

const subscriptionSlice = createSlice({
  name: "subscription",
  initialState,
  reducers: {
    clearCoupon: (s) => {
      s.coupon = { loading: false, error: null, data: null };
    },
  },
  extraReducers: (builder) => {
    // fetchPlans
    builder
      .addCase(fetchPlans.pending, (s) => { s.plans.loading = true; s.plans.error = null; })
      .addCase(fetchPlans.fulfilled, (s, a) => { s.plans.loading = false; s.plans.data = a.payload; })
      .addCase(fetchPlans.rejected, (s, a) => { s.plans.loading = false; s.plans.error = a.payload; });

    // fetchMySubscription
    builder
      .addCase(fetchMySubscription.pending, (s) => { s.mySubscription.loading = true; })
      .addCase(fetchMySubscription.fulfilled, (s, a) => { s.mySubscription.loading = false; s.mySubscription.data = a.payload; })
      .addCase(fetchMySubscription.rejected, (s, a) => { s.mySubscription.loading = false; s.mySubscription.error = a.payload; });

    // startCheckout
    builder
      .addCase(startCheckout.pending, (s) => { s.checkout.loading = true; s.checkout.error = null; })
      .addCase(startCheckout.fulfilled, (s) => { s.checkout.loading = false; })
      .addCase(startCheckout.rejected, (s, a) => { s.checkout.loading = false; s.checkout.error = a.payload; });

    // applyCoupon
    builder
      .addCase(applyCoupon.pending, (s) => { s.coupon.loading = true; s.coupon.error = null; s.coupon.data = null; })
      .addCase(applyCoupon.fulfilled, (s, a) => { s.coupon.loading = false; s.coupon.data = a.payload; })
      .addCase(applyCoupon.rejected, (s, a) => { s.coupon.loading = false; s.coupon.error = a.payload; });

    // cancel / resume / changePlan
    [cancelMySubscription, resumeMySubscription, changeMyPlan].forEach((thunk) => {
      builder
        .addCase(thunk.pending, (s) => { s.action.loading = true; s.action.error = null; })
        .addCase(thunk.fulfilled, (s) => { s.action.loading = false; })
        .addCase(thunk.rejected, (s, a) => { s.action.loading = false; s.action.error = a.payload; });
    });
  },
});

export const { clearCoupon } = subscriptionSlice.actions;
export default subscriptionSlice.reducer;
